import React from 'react';
import styles from './Thickness.scss';

const ThicknessIcon = ({ label }) => <div className={styles.icon}>{label}</div>;

export default ThicknessIcon;
